import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'connect.title',
    defaultMessage: 'Connect with ClassPass',
  },
  companyId: {
    id: 'connect.company-id',
    defaultMessage: 'Company ID',
  },
  apiKey: {
    id: 'connect.api-key',
    defaultMessage: 'API Key',
  },
  connect: {
    id: 'connect',
    defaultMessage: 'Connect',
  },
  instructions: {
    id: 'connect.mytime.instructions',
    defaultMessage:
      'Please input your MyTime credentials below - you can find these under Business Settings within MyTime or reach out to your MyTime representative.',
  },
  followup: {
    id: 'connect.mytime.followup',
    defaultMessage:
      "Once you have input your credentials and selected 'Connect', please inform your ClassPass representative or our onboarding team via launch@classpass.com that this step has been completed. The Onboarding Team will complete your integration prior to your page going live on ClassPass",
  },
});

export const sagaMessages = defineMessages({
  success: {
    id: 'connect.success',
    defaultMessage: 'Thank you, your credentials have been validated and saved properly.',
  },
  invalidCredentials: {
    id: 'connect.invalid-credentials',
    defaultMessage: 'The provided credentials cannot be validated, please make sure the values are correct.',
  },
});
